import { Chip } from '@mui/material';
import type { CriticalityDisplay } from 'utils/issueCriticality';

const TOKEN_COLORS: Record<string, string> = {
  'error.main': '#dc2626',
  'warning.main': '#ea580c',
  'success.main': '#16a34a',
  'text.secondary': '#6b7280'
};

const resolveChipColor = (color?: string) => {
  if (!color) return { bgcolor: '#f3f4f6', color: '#374151' };
  if (color.startsWith('#')) return { bgcolor: color, color: '#fff' };
  const hex = TOKEN_COLORS[color];
  if (hex) return { bgcolor: hex, color: '#fff' };
  return { bgcolor: '#f3f4f6', color: '#374151' };
};

export const CriticalityChip = ({
  criticality,
  size = 'small'
}: {
  criticality?: CriticalityDisplay;
  size?: 'small' | 'medium';
}) => {
  if (!criticality?.label) return null;
  const styles = resolveChipColor(criticality.color);
  return (
    <Chip
      size={size}
      label={criticality.label}
      sx={{
        fontSize: 10,
        fontWeight: 700,
        height: size === 'small' ? 22 : 26,
        ...styles
      }}
    />
  );
};
